import { Text } from 'components';
import { useTranslation } from 'react-i18next';

const CATEGORY_CODES = ['SCHEDULE', 'PAYMENT', 'INQUIRY', 'PASS_RESULT'] as const;

const I18N_KEYS: Record<(typeof CATEGORY_CODES)[number], string> = {
  SCHEDULE: 'manageMail.categories.schedule',
  PAYMENT: 'manageMail.categories.payment',
  INQUIRY: 'manageMail.categories.inquiry',
  PASS_RESULT: 'manageMail.categories.passResult'
};

const MailCategoryGuide = () => {
  const { t } = useTranslation();

  return (
    <div
      className="mx-6 mt-3 mb-1 rounded-lg border border-border-primary bg-bg-layer2 px-4 py-3"
      role="note"
      aria-label={t('manageMail.categories.guideTitle')}
    >
      <Text weight="medium" size="body2" color="secondary" className="mb-2 block">
        {t('manageMail.categories.guideTitle')}
      </Text>
      <ul className="list-none space-y-1.5 pl-0">
        {CATEGORY_CODES.map((code) => (
          <li key={code} className="text-start text-small leading-snug text-text-tertiary">
            <span className="font-medium text-text-primary">{code}</span>
            {' — '}
            {t(I18N_KEYS[code])}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MailCategoryGuide;
